import React, { useEffect, useState } from 'react';
import { properties } from '../../../properties';
import axios from 'axios';
import { env } from '../../../env';
import "../../../styles/ConsolidatedPayment.css";
import WebComponent from './WebComponent';
import BillingAddress from './BillingAddress';
import PopUpModal from '../../../Helper/PopUpModal';

const ConsolidatedUI = ({ apiUrl }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const baseURL = env.REACT_APP_BACKEND_URL;
    const enhancedRedirectUrl = env.REACT_APP_ENHANCED_REDIRECT_URL;
    const [isEmbedded, setIsEmbedded] = useState(true);
    const [isCustomCallback, setIsCustomCallback] = useState(false);
    const [isDpaFlag, setIsDpaFlag] = useState("No");
    const [showWebComponent, setShowWebComponent] = useState(false);
    const [paymentResult, setPaymentResult] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const [isFormDisabled, setisFormDisabled] = useState(false);

    const [checkoutParam, setCheckoutParam] = useState({
        isEmbedded: "Yes",
        apiVersion: "1",
        appId: "2",
        region: "EMEA-01",
        presentmentCurrency: "EUR",
        addressLine1: "",
        addressLine2: "",
        customerName: "Test Harness",
        countryCode: "",
        city: "",
        state: "",
        zip: "",
        email: "",
        amount: "",
        intentType: "SAVE_CARD",
        isPayPalTestMode: "No",
        payPalFakeNonce: properties.SEL_PAYPAL_FAKE_NONCE,
        locale: properties.SEL_LOCALE,
        declineRateLimit: "",
        captchaRetryAttempt: "3",
        disableCaptcha: "No",
        isCaptchaTestMode: "No",
        captchaSiteKey: properties.SEL_CAPTCHA_SITE_KEY,
        captchaTestDescription: properties.SEL_CAPTCHA_TEST_DESCRIPTION,
        phone: "",
        timestamp: "",
        buttonId: "",
        dpaFlag: false
    });
    /*
    const [paymentMethodAppearance, setPaymentMethodAppearance] = useState({
        stripe: {
            ".Label": {"color":"green","fontFamily":"Ideal Sans, system-ui, sans-serif"},
            ".Input": {"backgroundColor":"antiquewhite","borderRadius":"30px","borderColor":"purple","border":"2px solid"},
            ".Error": {"color": "purple"},
        }, paypal: {
            color: "gold",
            label: 'paypal'
        }
    });
    */
    const [redirectParam, setRedirectParam] = useState({ confirm: "" });
    var region = [];
    var intentType = [];
    var locale = [];
    var payPal_fake_nonce = [];
    var captcha_sitekey = [];
    var captcha_testDescription = [];
    var canSubmit = true;
    let apiVersions = [];

    for (let property in properties.REGIONS) {
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    for (let property in properties.INTENTTYPE) {
        intentType.push(<option value={property} key={property}>{properties.INTENTTYPE[property]}</option>);
    }

    for (let property in properties.LOCALE) {
        locale.push(<option value={property} key={property}>{properties.LOCALE[property]}</option>);
    }

    for (let verNumber of ["1", "2"]) {
        apiVersions.push(<option value={verNumber} key={`v${verNumber}`}>{`v${verNumber}`}</option>);
    }

    properties.PAYPAL_FAKE_NONCE.forEach((property) => {
        payPal_fake_nonce.push(<option value={property["value"]} key={property["value"]}>{property.value}</option>);
    });

    properties.CAPTCHA_SITE_KEY.forEach((property) => {
        captcha_sitekey.push(<option value={property["value"]} key={property["value"]}>{property.description}</option>);
    });

    properties.CAPTCHA_TEST_DESCRIPTION.forEach((property) => {
        captcha_testDescription.push(<option value={property["value"]} key={property["value"]}>{property.description}</option>);
    });

    function isNotNullCheck(e, field) {
        if (e === "" || !e) {
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else {
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeDpaFlag(e) {
        const dpaFlag = e.target.value === "Yes" ? true : false;
        setIsDpaFlag(e.target.value);
        setCheckoutParam({ ...checkoutParam, dpaFlag: dpaFlag });
    }

    function changeCustomCallback(e) {
        setIsCustomCallback(e.target.value);
    }

    function changeEmbeddedFlag(e) {
        const embeddedFlag = e.target.value === "Yes" ? true : false;
        setIsEmbedded(embeddedFlag);
        setCheckoutParam({ ...checkoutParam, isEmbedded: e.target.value });
    }

    function changeApiVersion(e) {
        setCheckoutParam({ ...checkoutParam, apiVersion: e.target.value });
    }

    function changeAppId(e) {
        isNotNullCheck(e.target.value, "WPS_appId");
        setCheckoutParam({ ...checkoutParam, appId: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value, "WPS_region");
        setCheckoutParam({ ...checkoutParam, region: e.target.value });
    }

    function changeCurrency(e) {
        if (checkoutParam.intentType !== "SAVE_CARD") {
            isNotNullCheck(e.target.value, "WPS_presentmentCurrency");
        }
        setCheckoutParam({ ...checkoutParam, presentmentCurrency: e.target.value });
    }

    function changeAmount(e) {
        if (checkoutParam.intentType !== "SAVE_CARD") {
            isNotNullCheck(e.target.value, "WPS_amount");
        }
        setCheckoutParam({ ...checkoutParam, amount: e.target.value });
    }

    function changeAddressLine1(e) {
        setCheckoutParam({ ...checkoutParam, addressLine1: e.target.value });
    }

    function changeAddressLine2(e) {
        setCheckoutParam({ ...checkoutParam, addressLine2: e.target.value });
    }

    function changeCustomerName(e) {
        isNotNullCheck(e.target.value, "WPS_customerName");
        setCheckoutParam({ ...checkoutParam, customerName: e.target.value });
    }

    function changePhone(e) {
        setCheckoutParam({ ...checkoutParam, phone: e.target.value });
    }

    function changeCountryCode(e) {
        setCheckoutParam({ ...checkoutParam, countryCode: e.target.value });
    }

    function changeCity(e) {
        setCheckoutParam({ ...checkoutParam, city: e.target.value });
    }

    function changeState(e) {
        setCheckoutParam({ ...checkoutParam, state: e.target.value });
    }

    function changeZip(e) {
        setCheckoutParam({ ...checkoutParam, zip: e.target.value });
    }

    function changeEmail(e) {
        isNotNullCheck(e.target.value, "WPS_email");
        setCheckoutParam({ ...checkoutParam, email: e.target.value });
    }

    function changeIntentType(e) {
        isNotNullCheck(e.target.value, "WPS_intentType");
        if (e.target.value === properties.INTENTTYPE.SAVE_CARD) {
            setCheckoutParam((prevValue) => { prevValue.amount = "" });
        }
        setCheckoutParam({ ...checkoutParam, intentType: e.target.value });
    }

    function changeIsPayPalTestMode(e) {
        setCheckoutParam({ ...checkoutParam, isPayPalTestMode: e.target.value });
    }

    function changeSubmitButtonId(e) {
        setCheckoutParam({ ...checkoutParam, buttonId: e.target.value });
    }

    function changeLocale(e) {
        setCheckoutParam({ ...checkoutParam, locale: e.target.value });
    }

    function changePayPalFakeNonce(e) {
        if (checkoutParam.isPayPalTestMode === true || checkoutParam.isPayPalTestMode === "Yes") {
            isNotNullCheck(e.target.value, "WPS_payPal_fake_nonce");
        }
        setCheckoutParam({ ...checkoutParam, payPalFakeNonce: e.target.value });
    }

    function changeCaptchaRetryAttempt(e) {
        setCheckoutParam({ ...checkoutParam, captchaRetryAttempt: e.target.value });
    }

    function changeDeclineRateLimit(e) {
        setCheckoutParam({ ...checkoutParam, declineRateLimit: e.target.value });
    }

    function changeIsCaptchaTestMode(e) {
        setCheckoutParam({ ...checkoutParam, isCaptchaTestMode: e.target.value });
    }

    /*
    function changePayPalButtonColor(e) {
        let copiedPaymentMethodAppearance = {
            stripe: {
                ".Label": { ...paymentMethodAppearance.stripe['.Label']},
                ".Input": { ...paymentMethodAppearance.stripe['.Input']},
                ".Error": { ...paymentMethodAppearance.stripe['.Error']},
            }, 
            paypal: { ...paymentMethodAppearance.paypal, color: e.target.value}
        };
        setPaymentMethodAppearance(copiedPaymentMethodAppearance);
    }

    function changeStripeLabelColor(e) {
        let copiedPaymentMethodAppearance = {
            stripe: {
                ".Label": { ...paymentMethodAppearance.stripe[".Label"], color: e.target.value},
                ".Input": { ...paymentMethodAppearance.stripe[".Input"]},
                ".Error": { ...paymentMethodAppearance.stripe[".Error"]},
            },
            paypal: { ...paymentMethodAppearance.paypal}
        };
        setPaymentMethodAppearance(copiedPaymentMethodAppearance);
    }

    function changeStripeErrorColor(e) {
        let copiedPaymentMethodAppearance = {
            stripe: {
                ".Label": { ...paymentMethodAppearance.stripe['.Label']},
                ".Input": { ...paymentMethodAppearance.stripe['.Input']},
                ".Error": { ...paymentMethodAppearance.stripe['.Error'], color: e.target.value},
            },
            paypal: { ...paymentMethodAppearance.paypal}
        };
        setPaymentMethodAppearance(copiedPaymentMethodAppearance);
    }
    */

    function changeIsCaptchaDisabled(e) {
        setCheckoutParam({ ...checkoutParam, disableCaptcha: e.target.value });
    }

    function changeCaptchaSitekey(e) {
        if (checkoutParam.isCaptchaTestMode === true || checkoutParam.isCaptchaTestMode === "Yes") {
            isNotNullCheck(e.target.value, "WPS_captcha_sitekey");
        }
        setCheckoutParam({ ...checkoutParam, captchaSiteKey: e.target.value });
    }

    function changeCaptchaTestDescription(e) {
        if (checkoutParam.isCaptchaTestMode === true || checkoutParam.isCaptchaTestMode === "Yes") {
            isNotNullCheck(e.target.value, "WPS_captchaTestDescription");
        }
        setCheckoutParam({ ...checkoutParam, captchaTestDescription: e.target.value });
    }

    function submitCheckout(e) {
        e.preventDefault();
        checkoutParam.timestamp = (Math.floor(Date.now() / 1000)).toString();
        isNotNullCheck(checkoutParam.appId, "WPS_appId");
        isNotNullCheck(checkoutParam.region, "WPS_region");
        if (checkoutParam.intentType !== "SAVE_CARD") {
            isNotNullCheck(checkoutParam.presentmentCurrency, "WPS_presentmentCurrency");
            isNotNullCheck(checkoutParam.amount, "WPS_amount");
        }
        else {
            delete checkoutParam.amount;
        }

        if (checkoutParam.addressLine1) {
            isNotNullCheck(checkoutParam.city, "WPS_city");
            isNotNullCheck(checkoutParam.countryCode, "WPS_countryCode");
            isNotNullCheck(checkoutParam.zip, "WPS_zip");
        }

        isNotNullCheck(checkoutParam.customerName, "WPS_customerName");
        isNotNullCheck(checkoutParam.email, "WPS_email");
        isNotNullCheck(checkoutParam.intentType, "WPS_intentType");

        if (canSubmit) {
            setIsLoading(true);
            delete checkoutParam["isEmbedded"];
            if(isEmbedded) {
                loadWPSWebComponentScript();
            }
            if (checkoutParam.region === "NoR") {
                setCheckoutParam({ ...checkoutParam, region: "" });
            }
            // let postURL = `${baseURL}/testclient/v${checkoutParam.apiVersion}/transaction/paynow`;
            // axios.post(postURL, checkoutParam)
            axios.post(baseURL + '/testclient/v1/transaction/paynow', checkoutParam)
                .then(res => {
                    checkoutParam.paymentToken = res.data.paymentToken;
                    checkoutParam.paymentReference = res.data.paymentReference;
                    if(isEmbedded) {
                        if (checkoutParam.apiVersion === "2") {
                            checkoutParam.paymentConfig = res.data.paymentConfiguration;
                        }
                        setShowWebComponent(true);
                        setIsLoading(false);
                    }
                    else {
                        setIsLoading(false);
                        window.location.href = `${enhancedRedirectUrl}?ref=${checkoutParam.paymentReference}&token=${checkoutParam.paymentToken}`;
                    }
                })
                .catch((err) => {
                    console.log("error", err)
                    setIsLoading(false);
                    setErrorMsg(JSON.stringify(err.response.data, undefined, 4));
                    setIsModalOpen(true);
                });
        }
    }

    const loadWPSWebComponentScript = () => {
        const wpsWebComponenetScript = document.getElementById('wpsWebComponentScript');
        wpsWebComponenetScript.src = checkoutParam.apiVersion === "2" ? env.REACT_APP_WEB_COMPONENT_V2_URL : env.REACT_APP_WEB_COMPONENT_URL;
        if (!wpsWebComponenetScript.src) {
            console.log(`Warning----> REACT_APP_WEB_COMPONENT_${checkoutParam.apiVersion === "2" ? 'V2_' : ''}URL not found`);
        }
    }

    useEffect(() => {
        if (urlParams.has("confirm")) {
            loadWPSWebComponentScript();
            redirectParam['confirm'] = urlParams.get("confirm");
            setShowWebComponent(true);
            setShowPayment(true);
            setisFormDisabled(true);
        }
    }, [urlParams])

    var checkoutTemplate = (
        <>
            {(showWebComponent && isEmbedded )? <div className='parent-consolidated-ui row'>
                <div className='left-panel-consolidated-ui'>
                    {showPayment ? <h2>Checkout</h2> : <h2>Billing Address</h2>}
                    {isError && paymentResult && <div id="wps-response-form">
                        <div style={{ padding: "20px" }}>
                            <h3 style={{ color: "red" }}>There was a problem with your payment!</h3>
                            <div><textarea id="responseTextarea" readOnly spellCheck="false" style={{ width: "80%", height: "150px" }} value={JSON.stringify(paymentResult, undefined, 4)}></textarea>
                            </div>
                        </div>
                    </div>}
                </div>
                <div className='right-panel-consolidated-ui'>
                    {!isSuccess ?
                        <>
                            <BillingAddress setShowPayment={setShowPayment} checkoutParam={checkoutParam} isFormDisabled={isFormDisabled} setisFormDisabled={setisFormDisabled} />
                            {showPayment &&
                                <>
                                    {checkoutParam.buttonId && <button className='btn btn-primary test-harness-payment-button' id={checkoutParam.buttonId}>Procced to Pay</button>}
                                    {checkoutParam.paymentReference && checkoutParam.paymentToken && 
                                        <WebComponent 
                                            checkoutParam={checkoutParam} 
                                            paymentMethodAppearance={null}
                                            isCustomCallback={isCustomCallback ? isCustomCallback : null}
                                            setIsError={setIsError}
                                            setIsSuccess={setIsSuccess}
                                            setPaymentResult={setPaymentResult}
                                        />
                                    }
                                    {redirectParam.confirm && <WebComponent checkoutParam={redirectParam} isCustomCallback={isCustomCallback ? isCustomCallback : null} setIsError={setIsError} setIsSuccess={setIsSuccess} setPaymentResult={setPaymentResult} />}
                                
                                </>}
                        </> :
                        <div id="wps-response-form">
                            {paymentResult &&
                                <div style={{ padding: "20px" }}>
                                    <h3 style={{ color: "green" }}>Thank you for your payment!</h3>
                                    <div><textarea id="responseTextarea" readOnly spellCheck="false" style={{ width: "80%", height: "150px" }} value={JSON.stringify(paymentResult, undefined, 4)}></textarea>
                                    </div>
                                </div>}
                        </div>
                    }
                </div>
            </div> :
                <><div className="operation-form">
                    <h2>Checkout</h2>
                    <form className="form-horizontal" id="checkoutForm" onSubmit={submitCheckout} method="POST">
                        <div className="form-group">
                            <div className="control-label">
                                Embedded
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_embeddeFlag" onChange={changeEmbeddedFlag} value={checkoutParam.isEmbedded}>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Dpa Flag
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_dpaFlag" onChange={changeDpaFlag} value={isDpaFlag}>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Add Custom Callback
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_customCallback" onChange={changeCustomCallback} value={isCustomCallback}>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                </select>
                            </div>
                        </div>
                        {/* <div className="form-group">
                            <div className="control-label">
                                WebComponent Version
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_apiVersion" onChange={changeApiVersion} value={checkoutParam.apiVersion}>
                                    {apiVersions}
                                </select>
                            </div>
                        </div> */}
                        <div className="form-group">
                            <div className="control-label">
                                Client Application ID<span className="mandatory-indicator">*</span>
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_appId" value={checkoutParam.appId} onChange={changeAppId} />
                                <div className="error-msg" name="WPS_appId">Client Application ID is mandatory</div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Region<span className="mandatory-indicator">*</span>
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_region" onChange={changeRegion} value={checkoutParam.region}>
                                    {region}
                                </select>
                                <div className="error-msg" name="WPS_region">Region is mandatory</div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                ISO Currency Code{checkoutParam.intentType !== "SAVE_CARD" && <span className="mandatory-indicator">*</span>}
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_presentmentCurrency" value={checkoutParam.presentmentCurrency} onChange={changeCurrency} />
                                {checkoutParam.intentType !== "SAVE_CARD" && (
                                    <div className="error-msg" name="WPS_presentmentCurrency">ISO Currency Code is mandatory</div>
                                )}
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Intent Type<span className="mandatory-indicator">*</span>
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_intentType" value={checkoutParam.intentType} onChange={changeIntentType}>
                                    {intentType}
                                </select>
                                <div className="error-msg" name="WPS_intentType">Intent Type is mandatory</div>
                            </div>
                        </div>
                        {checkoutParam.intentType !== "SAVE_CARD" && (
                            <div className="form-group">
                                <div className="control-label">
                                    Amount<span className="mandatory-indicator">*</span>
                                </div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" name="WPS_amount" value={checkoutParam.amount} onChange={changeAmount} />
                                    <div className="error-msg" name="WPS_amount">Amount is mandatory</div>
                                </div>
                            </div>
                        )}
                        <div className="form-group">
                            <div className="control-label">
                                Email<span className="mandatory-indicator">*</span>
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_email" value={checkoutParam.email} onChange={changeEmail} />
                                <div className="error-msg" name="WPS_email">Email is mandatory</div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Customer Name<span className="mandatory-indicator">*</span>
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_customerName" value={checkoutParam.customerName} onChange={changeCustomerName} />
                                <div className="error-msg" name="WPS_customerName">Customer Name is mandatory</div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Address Line 1
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_addressLine1" value={checkoutParam.addressLine1} onChange={changeAddressLine1} />
                            </div>
                        </div>
                        {checkoutParam.addressLine1 &&
                            <>
                                <div className="form-group">
                                    <div className="control-label">
                                        Address Line 2
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_addressLine2" value={checkoutParam.addressLine2} onChange={changeAddressLine2} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        Phone
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_phone" value={checkoutParam.phone} onChange={changePhone} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        ISO Country Code<span className="mandatory-indicator">*</span>
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_countryCode" value={checkoutParam.countryCode} onChange={changeCountryCode} />
                                        <div className="error-msg" name="WPS_countryCode">Country Code is mandatory</div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        City<span className="mandatory-indicator">*</span>
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_city" value={checkoutParam.city} onChange={changeCity} />
                                        <div className="error-msg" name="WPS_city">City is mandatory</div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        State
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_state" value={checkoutParam.state} onChange={changeState} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        Postal/Zip Code<span className="mandatory-indicator">*</span>
                                    </div>
                                    <div className="col-sm-5">
                                        <input type="text" className="form-control" name="WPS_zip" value={checkoutParam.zip} onChange={changeZip} />
                                        <div className="error-msg" name="WPS_zip">Postal Code is mandatory</div>
                                    </div>
                                </div>
                            </>}
                        <div className="form-group">
                            <div className="control-label">
                                Locale
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_locale" onChange={changeLocale} value={checkoutParam.locale}>
                                    {locale}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Captcha Retry Attempt Times
                            </div>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" name="WPS_captchaRetryAttempt" value={checkoutParam.captchaRetryAttempt} onChange={changeCaptchaRetryAttempt} />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                Submit Button Id
                            </div>
                            <div type="text" className="col-sm-5">
                                <input className="form-control" name="WPS_button_id" value={checkoutParam.buttonId} onChange={changeSubmitButtonId} />
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="control-label">
                                PayPal Test Mode
                            </div>
                            <div className="col-sm-5">
                                <select className="form-control" name="WPS_isPayPalTestMode" value={checkoutParam.isPayPalTestMode} onChange={changeIsPayPalTestMode}>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                        {(checkoutParam.isPayPalTestMode === "Yes" || checkoutParam.isPayPalTestMode === true) && (
                            <div className="form-group">
                                <div className="control-label">
                                    PayPal Fake Nonce<span className="mandatory-indicator">*</span>
                                </div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="WPS_payPal_fake_nonce" onChange={changePayPalFakeNonce} value={checkoutParam.payPalFakeNonce}>
                                        {payPal_fake_nonce}
                                    </select>
                                    <div className="error-msg" name="WPS_payPal_fake_nonce">PayPal Fake Nonce is mandatory</div>
                                </div>
                            </div>
                        )}
                        <>
                            <div className="form-group">
                                <div className="control-label">
                                    Credit Card Decline Rate Limit
                                </div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" name="WPS_declineRateLimit" value={checkoutParam.declineRateLimit} onChange={changeDeclineRateLimit} />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="control-label">
                                    Disable Captcha
                                </div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="WPS_isCaptchaDisabled" value={checkoutParam.disableCaptcha} onChange={changeIsCaptchaDisabled}>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="control-label">
                                    Credit Card Captcha Test Mode
                                </div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="WPS_isCaptchaTestMode" value={checkoutParam.isCaptchaTestMode} onChange={changeIsCaptchaTestMode}>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                        </>
                        {(checkoutParam.isCaptchaTestMode === "Yes" || checkoutParam.isCaptchaTestMode === true) && (
                            <>
                                <div className="form-group">
                                    <div className="control-label">
                                        Credit Card Captcha Sitekey<span className="mandatory-indicator">*</span>
                                    </div>
                                    <div className="col-sm-5">
                                        <select className="form-control" name="WPS_captcha_sitekey" onChange={changeCaptchaSitekey} value={checkoutParam.captchaSiteKey}>
                                            {captcha_sitekey}
                                        </select>
                                        <div className="error-msg" name="WPS_captcha_sitekey">Captcha Sitekey is mandatory</div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="control-label">
                                        Credit Card Captcha Test Description<span className="mandatory-indicator">*</span>
                                    </div>
                                    <div className="col-sm-5">
                                        <select className="form-control" name="WPS_captchaTestDescription" onChange={changeCaptchaTestDescription} value={checkoutParam.captchaTestDescription}>
                                            {captcha_testDescription}
                                        </select>
                                        <div className="error-msg" name="WPS_captchaTestDescription">Captcha Test Description is mandatory</div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* <div className='form-group'>
                            <div className='control-label'>
                                PayPal Button Color
                            </div>
                            <div className='col-sm-5'>
                                <select className='form-control' name='paypal-btn-color' value={paymentMethodAppearance.paypal.color} onChange={changePayPalButtonColor} >
                                    <option value="blue">Blue</option>
                                    <option value="gold">Gold</option>
                                    <option value="silver">Silver</option>
                                    <option value="black">Black</option>
                                </select>
                            </div>
                        </div> */}
                        {/* <div className='form-group'>
                            <div className='control-label'>
                                Stripe Label Color
                            </div>
                            <div className='col-sm-5'>
                                <input type="text" className="form-control" name="stripe-label-color" value={paymentMethodAppearance.stripe['.Label'].color} onChange={changeStripeLabelColor} />
                            </div>
                        </div> */}
                        {/* <div className='form-group'>
                            <div className='control-label'>
                                Stripe Error Color
                            </div>
                            <div className='col-sm-5'>
                            <input type="text" className="form-control" name="stripe-error-color" value={paymentMethodAppearance.stripe[".Error"].color} onChange={changeStripeErrorColor} />
                            </div>
                        </div> */}
                        <div className="form-group">
                            <div className="col-sm-5">
                                {!isLoading ? <button type="submit" className="btn btn-primary">Continue</button> : <div className='spinnerConsumer'></div>}
                            </div>
                        </div>
                    </form>
                </div>
                    {isModalOpen && <PopUpModal errorMsg={errorMsg} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
                </>
            }

        </>
    );

    return checkoutTemplate
}

export default ConsolidatedUI;
